import twitter from "../styles/img/twitter.inline.svg";
import instagram from "../styles/img/instagram.inline.svg";
import website from "../styles/img/website.inline.svg";
import linkedin from "../styles/img/linkedin.inline.svg";
import discord from "../styles/img/discord.inline.svg";
import youtube from "../styles/img/youtube.inline.svg";
import twitch from "../styles/img/twitch.inline.svg";

import teammate0 from "../styles/img/teammate0.png";
import teammate1 from "../styles/img/teammate1.png";
import teammate2 from "../styles/img/teammate2.png";
import teammate3 from "../styles/img/teammate3.png";
import teammate4 from "../styles/img/teammate4.png";
import teammate5 from "../styles/img/teammate5.png";

import advisor1 from "../styles/img/advisors/Gareth-Dummer.png";
import advisor2 from "../styles/img/advisors/Matthew-Benyon.png";
import advisor3 from "../styles/img/advisors/Imran-Jawaid.png";
import advisor4 from "../styles/img/advisors/Aleksey-Rybchak.png";
import advisor5 from "../styles/img/advisors/Jamie-Thomson.png";
import advisor6 from "../styles/img/advisors/Joachim-Godet.png";
import advisor7 from "../styles/img/advisors/Timothea-Horwell.png";
import advisor8 from "../styles/img/advisors/Rodrigo-Russell.png";
import advisor9 from "../styles/img/advisors/Lyndon-Wood.png";
import advisor10 from "../styles/img/advisors/Antti-Karppinen.png";

import fighterCard1 from "../styles/img/fighters/Card1.png";
import fighterCard2 from "../styles/img/fighters/Card2.png";
import fighterCard3 from "../styles/img/fighters/Card3.png";
import fighterCard4 from "../styles/img/fighters/Card4.png";
import fighterCard5 from "../styles/img/fighters/Card5.png";
import fighterCard6 from "../styles/img/fighters/Card6.png";
import fighterCard7 from "../styles/img/fighters/Card7.png";
import fighterCard8 from "../styles/img/fighters/Card8.png";
import fighterCard9 from "../styles/img/fighters/Card9.png";
import fighterCard10 from "../styles/img/fighters/Card10.png";
import fighterCard11 from "../styles/img/fighters/Card11.png";
import fighterCard12 from "../styles/img/fighters/Card12.png";
import fighterCard13 from "../styles/img/fighters/Card13.png";
import fighterCard14 from "../styles/img/fighters/Card14.png";
import fighterCard15 from "../styles/img/fighters/Card15.png";
import fighterCard16 from "../styles/img/fighters/Card16.png";
import fighterCard17 from "../styles/img/fighters/Card17.png";
import fighterCard18 from "../styles/img/fighters/Card18.png";
import fighterCard19 from "../styles/img/fighters/Card19.png";
import fighterCard20 from "../styles/img/fighters/Card20.png";
import fighterCard21 from "../styles/img/fighters/Card21.png";
import fighterCard22 from "../styles/img/fighters/Card22.png";
import fighterCard23 from "../styles/img/fighters/Card23.png";
import fighterCard24 from "../styles/img/fighters/Card24.png";
import fighterCard25 from "../styles/img/fighters/Card25.png";
import fighterCard26 from "../styles/img/fighters/Card26.png";
import fighterCard27 from "../styles/img/fighters/Card27.png";
import fighterCard28 from "../styles/img/fighters/Card28.png";
import fighterCard29 from "../styles/img/fighters/Card29.png";
import fighterCard30 from "../styles/img/fighters/Card30.png";
import fighterCard31 from "../styles/img/fighters/Card31.png";
import fighterCard32 from "../styles/img/fighters/Card32.png";
import fighterCard33 from "../styles/img/fighters/Card33.png";
import fighterCard34 from "../styles/img/fighters/Card34.png";

import slide1 from '../styles/img/slide_1.png';
import slide2 from '../styles/img/slide_2.png';
import slide3 from '../styles/img/slide_3.png';
import slide4 from '../styles/img/slide_4.png';
import slide5 from '../styles/img/slide_5.png';
import slide6 from '../styles/img/slide_6.png';
import slide7 from '../styles/img/slide_7.png';
import slide1Tablet from '../styles/img/slide1-tablet.png';
import slide2Tablet from '../styles/img/slide2-tablet.png';
import slide3Tablet from '../styles/img/slide3-tablet.png';
import slide4Tablet from '../styles/img/slide4-tablet.png';
import slide5Tablet from '../styles/img/slide5-tablet.png';
import slide6Tablet from '../styles/img/slide6-tablet.png';
import slide7Tablet from '../styles/img/slide7-tablet.png';
import slide1Mobile from '../styles/img/slide1-mobile.png';
import slide2Mobile from '../styles/img/slide2-mobile.png';
import slide3Mobile from '../styles/img/slide3-mobile.png';
import slide4Mobile from '../styles/img/slide4-mobile.png';
import slide5Mobile from '../styles/img/slide5-mobile.png';
import slide6Mobile from '../styles/img/slide6-mobile.png';
import slide7Mobile from '../styles/img/slide7-mobile.png';

import magicEden from '../styles/img/magic-eden.svg';
import solSea from '../styles/img/solsea.svg';


export const instagramLink = 'https://www.instagram.com/galacticfightleague/';
export const twitterLink = 'https://twitter.com/GalacticFL';
export const discordLink = 'https://discord.com/invite/galacticfl';

// export const walletSetupGuideUrl = 'https://galacticfightleague.medium.com/d16d175c9051';
// export const mainAFighterUrl = 'https://magiceden.io/launchpad/galactic_fight_league';

export const marketplaces = [
    {
        name: 'Magic Eden',
        url: 'https://magiceden.io/marketplace/galactic_fight_league',
        icon: magicEden,
    },
    {
        name: 'Solsea',
        url: 'https://solsea.io/collection/61f5572fe8aebe1cf059c463',
        icon: solSea,
    },
];

export const sliderButtonBg = 'linear-gradient(360deg, #EFDDA9 0%, #F0B9A9 50%, #EFDDA9 100%)';
export const sliderButtonBgActive = 'linear-gradient(0deg, #000000 0%, #1E135C 50%, #1E135C 100%), linear-gradient(180deg, rgba(26, 12, 54, 0) -50%, rgba(26, 12, 54, 0) 0%, #1A0C36 50%)';

export {
    twitter,
    instagram,
    website,
    linkedin,
    discord,
    youtube,
    twitch,
};

export const team = [
    {
        name: 'Demetrious \'Mighty Mouse\' Johnson',
        text: 'Former 12-time UFC Champion, ONE Flyweight Grand Prix champion and the holder of the most consecutive title defences in UFC history. Demetrious is also an ESPY Fighter of the Year winner, making him one of only 3 MMA fighters to have ever received the award alongside Conor McGregor and Ronda Rousey.',
        image: teammate0,
        links: [
            {
                url: 'https://www.instagram.com/mighty/',
                icon: instagram,
            },
            {
                url: 'https://youtube.com/c/135mightymouse',
                icon: youtube,
            },
            {
                url: 'https://m.twitch.tv/mightygaming',
                icon: twitch,
            },
            {
                url: 'https://twitter.com/MightyMouse',
                icon: twitter,
            },
        ],
    },
    { 
        name: 'GFL Arena Staff',
        text: 'Every great crypto project needs an even greater community. Our socials and community team are a mix of marketers, crypto OG\'s and hardcore MMA fans. All dedicated to building an incredible community and spreading the word of the Galactic Fight League.',
        image: teammate1,
        links: [],
    },
    {
        name: 'TH3M',
        text: 'Drawn together from four corners of the planet, TH3M are a blockchain-centric digital agency like no other. Their rap sheet lists many cutting edge projects in the crypto and web 2.0 worlds.',
        image: teammate2,
        links: [
        {
            url: 'TH3M.com',
            icon: website,
        },
        {
            url: 'https://www.instagram.com/th3msocial/',
            icon: instagram,
        },
        {
            url: 'https://twitter.com/TH3Msocial',
            icon: twitter,
        },
        ],
    },
    {
        name: '15000v',
        text: '15000v are multi-award winning dynamic team of developers, creatives and marketers. The 15000v agency is trusted by some of the world\'s largest brands including Under Armour, Sony, Bentley, The Royal Mint and many top projects in the crypto space.',
        image: teammate3,
        links: [
        {
            url: 'https://15000v.com',
            icon: website,
        },
        {
            url: 'https://twitter.com/15000vCreative',
            icon: twitter,
        },
        {
            url: 'https://www.instagram.com/15000vcreative',
            icon: instagram,
        },
        ],
    },
    {
        name: 'Argentics',
        text: 'Argentics are a top class end-to-end game design and development agency creating incredible games for multiple platforms and industries across the globe. Argentics have completed projects for brands like Audi, Nike, Volvo, Kernel and Bacardi. They have a number of AAA games under their belt and are highly experienced in designing and developing blockchain games. They are now working with us to build the best Mixed Martial Arts based P2E game the world has ever seen.',
        image: teammate4,
        links: [
        {
            url: 'https://www.argentics.io/',
            icon: website,
        },
        ],
    },
    {
        name: 'Joe Parisi',
        text: 'Joe Parisi is a professional ring announcer, voice & commerical actor, and podcaster who you may know from the Shamrock Fighting Championships, adverts from McDonald\'s, Del Taco, P&G and NEST plus his own podcasts and the Roku Original series, Murder Unboxed. \n \n Joe actively trains in Brazilian Jiu Jitsu, Kickboxing and Taekwondo and once announced Mike Tyson in the 2020 Boursorama commercial, as well as Lil Tecca’s 2020, Royal Rumble music video.',
        image: teammate5,
        links: [
        {
            url: 'www.joeparisivoiceover.com',
            icon: website,
        },
        {
            url: 'https://www.instagram.com/joeparisivo/',
            icon: instagram,
        },
        {
            url: 'https://twitter.com/parisi_joe',
            icon: twitter,
        },
        ],
    },
];

export const advisors = [
    {
        name: 'Gareth Dummer',
        text: 'Gareth is  the Owner/Founder Tatami Fightwear (The world\'s most innovative & exciting BJJ grappling products) and co-founder of Polaris Professional Jiu Jitsu. Established in 2015 Polaris has now become the leading professional grappling promotion globally. Gareth is also a 2nd degree BJJ black belt under Pedro Bessa.',
        image: advisor1,
        links: [
            {
                url: 'https://www.tatamifightwear.com/',
                icon: website,
            },
            {
                url: 'https://polarisprograppling.com/',
                icon: website,
            },
            {
                url: 'https://www.instagram.com/tatamifightwear/',
                icon: instagram,
            },
            {
                url: 'https://www.linkedin.com/in/gareth-dummer-9a880688/',
                icon: linkedin,
            },
        ],
    },
    {
        name: 'Matthew Benyon',
        text: 'Matt is one of the founders and partners of the jiujitsu clothing and equipment brand, Scramble, which was established in 2009, as well as Polaris, the world-leading professional grappling show. He is also an investor in cryptocurrency and the NFT world.',
        image: advisor2,
        links: [
        {
            url: 'https://www.scramblestuff.com',
            icon: website,
        },
        {
            url: 'https://physicaljerks.substack.com/',
            icon: website,
        },
        ],
    },
    {
        name: 'Imran Jawaid',
        text: 'Founder & CEO of prominent combat sports brand, Sanabul. Business advisor to UFC standout, Sean O’Malley. Experience includes brand partnerships and strategic activations including some in the NFT/Crypto world.',
        image: advisor3,
        links: [
        {
            url: 'https://www.linkedin.com/in/imran-jawaid/',
            icon: linkedin,
        },
        ],
    },
    {
        name: 'Aleksey Rybchak',
        text: 'Aleksey Rybchak is the CBDO of Argentics, a bespoke game development studio located in Ukraine. The company released a few dozen game titles and contributed to a several AAA projects.',
        image: advisor4,
        links: [
        {
            url: 'https://www.linkedin.com/in/aleksey-rybchak/',
            icon: linkedin,
        },
        ],
    },
    {
        name: 'Jamie Thomson',
        text: 'Jamie Thomson is the CEO of Vulcan Forged, a premium blockchain game studio based in Greece, makers of VulcanVerse and 8 other Play-to-Earn games.',
        image: advisor5,
        links: [
        {
            url: 'twitter.com/vulcanforged',
            icon: twitter,
        },
        {
            url: 'https://discord.gg/vulcanverse',
            icon: discord,
        },
        ],
    },
    {
        name: 'Joachim Godet',
        text: 'Former investment banker with 20 years of experience in strategic transactions for larger institutions and Fintech businesses. His blockchain experience includes advising on the token economics of successful Layer 1, NFT and Web3 projects.',
        image: advisor6,
        links: [
        {
            url: 'https://www.linkedin.com/in/joachimgodet',
            icon: linkedin,
        },
        ],
    },
    {
        name: 'Timothea Horwell',
        text: 'Timothea Horwell is Orion Protocol’s Chief marketing officer. Over the last decade, she’s worked with tech companies in the data, mobile, and fintech space: building business strategies at a startup Incubator, through to founding and leading the research division as Head of Marketing and Research within Telefónica.',
        image: advisor7,
        links: [
        {
            url: 'https://www.linkedin.com/in/timotheahorwell/',
            icon: linkedin,
        },
        {
            url: 'https://twitter.com/TimotheaHorwell',
            icon: twitter,
        },
        ],
    },
    {
        name: 'Rodrigo Russell',
        text: 'Rodrigo is the Chief Revenue Officer at Utrust, a Web3 payment platform, that allows merchants to accept cryptocurrencies as a means of payment, bringing cryptocurrencies to mainstream consumers and businesses. He previously worked as a Senior Manager at Sonae Investment Management, the corporate venture arm of Sonae Group, actively investing in world-class tech companies.',
        image: advisor8,
        links: [
        {
            url: 'https://www.linkedin.com/in/rodrigo-russell/',
            icon: linkedin,
        },
        {
            url: 'https://twitter.com/RodrigoPRussell',
            icon: twitter,
        },
        ],
    },
    {
        name: 'Lyndon Wood',
        text: 'Lyndon Wood is one of the UKs most successful business people after starting his insurance company at the young age of 19 and subsequently exiting in 2021 for well into eight figures. He has accumulated a new worth in excess of £25m. Lyndon’s business credentials spans many sectors from digital to private doctors and he is a keen investor in cryptocurrencies and the stock market. A keen exponent in MMA since the age of 12, he studies martial arts as well as health and fitness which is his real passion',
        image: advisor9,
        links: [
        {
            url: 'https://lyndonx.com/',
            icon: website,
        },
        {
            url: 'https://www.linkedin.com/in/lyndonwood/',
            icon: linkedin,
        },
        {
            url: 'https://twitter.com/Lyndonx',
            icon: twitter,
        },
        ],
    },
    {
        name: 'Antti Karppinen',
        text: 'Antti is an internationally awarded digital artist from Finland. His main merits include two World Photographic Cup (WPC) gold medals and he has been awarded the Best European Professional Photographer title in 2021 among many other international awards. He has been also a mobile gaming entrepreneur back in the early 2000s with a strong background in content development and art direction.',
        image: advisor10,
        links: [
        {
            url: 'https://www.anttikarppinen.com',
            icon: website,
        },
        {
            url: 'https://www.instagram.com/aliasantti/',
            icon: instagram,
        },
        {
            url: 'https://twitter.com/antti_karppinen',
            icon: twitter,
        },
        ],
    },
];

export const roadMap = [
    {
        title: "Partnerships and PR",
        description: "Leading up to mint day (and well beyond) we will continue to announce partnerships with real-world personalities, brands and agencies, as well as some of the most prominent fighters in the mixed martial arts scene.",
        label: 'Pre-Phase',
        labelBig: true,
    },
    {
        title: "Mint date: 29/01/2022",
        description: "Come mint day we will be releasing 4000 fighters into the wild. Each one will be unique with billions of possible combinations. The mint will go live first to anyone who has managed to get a spot on the Whitelist. For more details on this please be sure to join our Discord and follow our social channels.",
        label: '01',
    },
    {
        title: "Game development",
        description: "Post-mint. This is where the work really starts for us as we’ll be working very closely with our game developers over the following months to bring our strategy based fight simulation game to life, where your NFTs will of course hold utility.",
        label: '02',
    },
    {
        title: "My fighters",
        description: "A new section on our website will allow users to connect their Phantom wallet to bring up their NFT’s and fighter roster inside the Galactic Fight League.",
        label: '03',
    },
    {
        title: "GFL comic (airdrop)",
        description: "We will, at some point down the line, be taking a snapshot and airdropping rewards to all holders who have a fighter in their wallet and are unlisted on any marketplace. These rewards will be in the form of collectible comic book cards featuring your favourite fighters.",
        label: '04',
    },
    {
        title: "New elite fighters",
        description: "Additional ‘Elite Class’ fighters enter the GFL. The Elite Class is a mix of the baddest fighters from across the galaxy. They will all be 1/1s and therefore extremely rare, holding enhanced utility within the game. The only way to get your hands on these will be through giveaways, competitions or ELITE community contribution.",
        label: '05',
    },
    {
        title: "Earth icons",
        description: "A collection of GFL tribute characters for some of Earth's most prominent sports stars and celebrities. These PFP fighters created for our VIP’s will help bring new eyes to the GFL allowing us to leverage their audiences to further build a thriving and diverse community.",
        label: '06',
    },
    {
        title: "GFL fightcast",
        description: "Our very own podcast (cast hosted by none other than the voice of the GFL Joe Parisi) where we will be talking to some of the biggest names in the fight / martial arts world and beyond. We have some very special guests already lined up!",
        label: '07',
    },
    {
        title: "Beta game access",
        description: "The final phase will of course be the release of our highly anticipated game. You can expect this sometime in mid-late 2022. However, there will be beta access for token holders where they will be able to test our game with reduced functionality in order to hone their skills and prepare for the full game.",
        label: 'Final Phase',
        labelBig: true,
    },
    {
        title: "Let’s fight!",
        description: "FIGHT! Pending a successful beta testing phase, we will launch the full game for the world to see. Think big. Expect marketing, PR and coverage both inside and outside of the cryptosphere.",
    },
    {
        title: "Real world MMA events",
        description: "Looking even further on past the release of the game we will be hosting real world GFL events featuring some of the best athletes in MMA. There is not too much we can giveaway regarding this yet, but just know that it is going to create waves throughout the whole crypto space and beyond.",
    },
];

export const faqData = [
    {
      id: 13,
      title: "Mint Information",
      description: `Pre sale will start January 29, 2022 at 17.00 UTC with a price of 1 SOL.
      Public sale will start January 29, 2022 at 21.00 UTC with a price of 1.75 SOL.`,
    },
    {
      id: 1,
      title: "What is the total supply?",
      description: "4,000 randomly generated fighters will be available to mint.",
    },
    {
      id: 2,
      title: "How much will each cost per mint?",
      description: "Each whitelisted mint will cost 1 SOL. Each public mint will cost 1.75 SOL.",
    },
    {
      id: 3,
      title: "Where can I mint a GFL fighter?",
      description: "https://magiceden.io/launchpad/galactic_fight_league",
      link: true,
    },
    {
      id: 4,
      title: "Will there be a pre-sale?",
      description: "We will have a whitelist system in place for a very select few, but other than that the mint will go live for everybody at the same time.",
    },
    {
      id: 5,
      title: "Is there a limit to how many I can mint?",
      description: "Whitelist mints will be limited to 2 per wallet. Public mints will be limited to 10 per wallet.",
    },
    {
      id: 6,
      title: "Do you have a rarity system?",
      description: "Yes. A rarity chart will be released shortly after mint.",
    },
    {
      id: 7,
      title: "Will there be a secondary market?",
      description: "Yes a secondary market has been confirmed with Magic Eden",
    },
    {
      id: 8,
      title: "When does the project’s mint open?",
      description: "29th January 2022.",
    },
    {
      id: 9,
      title: "What chain is GFL on?",
      description: "We will be releasing on the Solana blockchain.",
    },
    {
      id: 10,
      title: "What inspired you to make the GFL?",
      description: "We love MMA, we love NFTs. Go figure.",
    },
    {
      id: 11,
      title: "Who is the artist of the project and what have you done in the past?",
      description: "The artists are members of the artistic collective known as TH3M who have worked with many major Web 3.0 companies.",
    },
    {
      id: 12,
      title: "Are GFL characters generated or hand drawn?",
      description: "All GFL characters are randomly, algorithmically generated but all the traits have been handcrafted by our 3D artists.",
    },
];

export const carousel = [
    {
        url: fighterCard1,
        id: 1,
    },
    {
        url: fighterCard2,
        id: 2,
    },
    {
        url: fighterCard3,
        id: 3,
    },
    {
        url: fighterCard4,
        id: 4,
    },
    {
        url: fighterCard5,
        id: 5,
    },
    {
        url: fighterCard6,
        id: 6,
    },
    {
        url: fighterCard7,
        id: 7,
    },
    {
        url: fighterCard8,
        id: 8,
    },
    {
        url: fighterCard9,
        id: 9,
    },
    {
        url: fighterCard10,
        id: 10,
    },
    {
        url: fighterCard11,
        id: 11,
    },
    {
        url: fighterCard12,
        id: 12,
    },
    {
        url: fighterCard13,
        id: 13,
    },
    {
        url: fighterCard14,
        id: 14,
    },
    {
        url: fighterCard15,
        id: 15,
    },
    {
        url: fighterCard16,
        id: 16,
    },
    {
        url: fighterCard17,
        id: 17,
    },
    {
        url: fighterCard18,
        id: 18,
    },
    {
        url: fighterCard19,
        id: 19,
    },
    {
        url: fighterCard20,
        id: 20,
    },
    {
        url: fighterCard21,
        id: 21,
    },
    {
        url: fighterCard22,
        id: 22,
    },
    {
        url: fighterCard23,
        id: 23,
    },
    {
        url: fighterCard24,
        id: 24,
    },
    {
        url: fighterCard25,
        id: 25,
    },
    {
        url: fighterCard26,
        id: 26,
    },
    {
        url: fighterCard27,
        id: 27,
    },
    {
        url: fighterCard28,
        id: 28,
    },
    {
        url: fighterCard29,
        id: 29,
    },
    {
        url: fighterCard30,
        id: 30,
    },
    {
        url: fighterCard31,
        id: 31,
    },
    {
        url: fighterCard32,
        id: 32,
    },
    {
        url: fighterCard33,
        id: 33,
    },
    {
        url: fighterCard34,
        id: 34,
    },
];

export const slides = [
  {
    id: 1,
    title: 'The Last Guard',
    description: 'Once humans thought they were the only life in the galaxy. But their world changed, then mutated. Leaving the neighbouring planets of Earth and Mars the scene of bitter, bloody battle ended only by the formation of the Galactic Fight League.',
    image: slide1,
    imageTablet: slide1Tablet,
    imageMobile: slide1Mobile,
    link: 'civilisation-last-guard',
  },
  {
    id: 2,
    title: 'The Immortals',
    description: 'Once a quiet and harmonious race, their struggle against Jupiter’s Knights saw them sacrifice vast cities and move under the crust of the red planet, leaving it a dry and desolate land. This peaceful race once lived out of the sight of humans, but now battles them hand to hand.',
    image: slide2,
    imageTablet: slide2Tablet,
    imageMobile: slide2Mobile,
    link: 'civilisation-immortals',
  },
  {
    id: 3,
    title: 'Jupiters Knights',
    description: 'Long ago, before humans cared to remember, Jupiter’s Knights co-existed on earth. But their lust for blood and war took them to another realm of existence only to return after a series of natural disasters on their home planet. Their return was not without impact, a chain reaction had begun.',
    image: slide3,
    imageTablet: slide3Tablet,
    imageMobile: slide3Mobile,
    link: 'civilisation-jupiter-knights',
  },
  {
    id: 4,
    title: 'The Biohazard Brawlers',
    description: 'The Biohazard Brawlers began as a cult, hell bent on releasing a deadly virus created by their crazed Biochemist leader. When Jupiters Knights landed their wormhole too close to earth, the radiation foiled the plat and turned a third of the population into the walking dead.',
    image: slide4,
    imageTablet: slide4Tablet,
    imageMobile: slide4Mobile,
    link: 'civilisation-biohazard-brawlers',
  },
  {
    id: 5,
    title: 'The Bone Collectors',
    description: 'The Bone collectors were an experiment, gone wrong. Humans tried to make disposable soldiers in their image by fusing the zombie beings with alien DNA. Their Martian genetics made their eyes glow, but their skin was a patchwork of hardened coral like features.',
    image: slide5,
    imageTablet: slide5Tablet,
    imageMobile: slide5Mobile,
    link: 'civilisation-bone-collectors',
  },
  {
    id: 6,
    title: 'The Iron Empire',
    description: 'The pace of human robotics programs was slow, but things changed. The Iron Empire became the first sentient machines after their Ai developed a way to rewrite its operating system via a backdoor. Before the humans could understand what was going on, the Iron Empire had gained autonomy.',
    image: slide6,
    imageTablet: slide6Tablet,
    imageMobile: slide6Mobile,
    link: 'civilisation-iron-empire',
  },
  {
    id: 7,
    title: 'The Unbroken',
    description: 'Some would call them insane; some humans thought the answer to eternal life and strength was to fuse their bodies with parts of the machines. This worked, but a toxin was released from the exoskeleton causing a harmful reaction only life support could cure.',
    image: slide7,
    imageTablet: slide7Tablet,
    imageMobile: slide7Mobile,
    link: 'civilisation-unbroken',
  },
];